// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__2D2uy","avatarPlaceholder":"avatar_avatarPlaceholder__1p-Rp","avatarInitials":"avatar_avatarInitials__1o5XU"};